import {
  Box, DashboardModule,
} from '@domain-group/suit-theme'

import { InvoiceModel } from '@models/types'

import useInvoiceAttachments from '@hooks/useInvoiceAttachments'

import AttachmentListItem from './AttachmentListItem'

type InvoiceAttachmentsProps = {
  invoice: InvoiceModel,
}

const InvoiceAttachments = (props: InvoiceAttachmentsProps) => {
  const { invoice } = props

  const useInvoiceAttachmentsPayload = useInvoiceAttachments({ filters: { invoice_id: invoice.id } })

  const {
    filteredInvoiceAttachments,
    hasFilteredInvoiceAttachments,
  } = useInvoiceAttachmentsPayload

  return (
    <DashboardModule title="Invoice Attachments">
      <Box flexDirection="column">
        {!hasFilteredInvoiceAttachments && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Attachments present
            </DashboardModule.BlankState.Title>
          </DashboardModule.BlankState>
        )}

        {hasFilteredInvoiceAttachments && (
          <DashboardModule.ScrollableSection>
            {filteredInvoiceAttachments.map(attachment => (
              <AttachmentListItem
                attachment={attachment}
                key={attachment.id}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}
      </Box>
    </DashboardModule>
  )
}

export default InvoiceAttachments
